import React from 'react'
import { Grid, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

interface SpecificationItemProps {
  label: string
  value: string
}
const useStyles = makeStyles((theme: Theme) => {
  return {
    itemContainer: {
      marginBottom: theme.spacing(4),
    },
    label: {
      fontWeight: 900,
    },
  }
})
const SpecificationItem = ({ label, value }: SpecificationItemProps) => {
  const classes = useStyles()

  return (
    <>
      <Grid container className={classes.itemContainer}>
        <Grid item sm={4} className={classes.label}>
          {label}:
        </Grid>
        <Grid item sm={8}>
          {value}
        </Grid>
      </Grid>
    </>
  )
}
export default SpecificationItem
